import React from "react";
// components
import Rooms from "../../components/Rooms";
import HeroVideo from "../../components/HeroVideo";
import StickyBookingBar from "../../components/StickyBookingBar";
import Gallery from "../../components/Gallery";
import Welcome from "../../components/Welcome";
import Services from "../../components/Services";
import Movie from "../../components/Movie";
import View360 from "../../components/View360";
import Location from "../../components/Location";
import ServicesHotel from "../../components/ServicesHotel";
import PackagesSection from "../../components/PackagesSection";
import GiftCardBanner from "../../components/GiftCardBanner";
import SEO from "../../components/SEO";

const HomePage = () => {
  return (
    <>
      <SEO path="/" />
      <HeroVideo />
      <StickyBookingBar />
      <div id="welcome">
        <Welcome />
      </div>
      <Rooms />
      <PackagesSection />
      <GiftCardBanner />
      <View360 bg={"bg-secondary"} />
      <Movie />
      <ServicesHotel />
      <Services />
      <Gallery />
      <Location />
    </>
  );
};

export default HomePage;
